/**
 * main.ts
 *
 * Bootstraps Vuetify and other plugins then mounts the App`
 */

// Components
import App from './App.vue'

// Composables
import { createApp } from 'vue'

// Plugins
import { registerPlugins } from '@/plugins'

import CanDirective from '@/directives/can'
import _ from 'lodash'

const app = createApp(App)

app.directive('can', CanDirective)

registerPlugins(app)

app.mount('#app')
